module.exports = __webpack_public_path__ + "img/Icons-2.7f1f8b9.svg";